
export const Bio = {
  name: "Kisho Jeyapragash",
  email: "kishojeyapragash@gmail.com",
  phone: "+94 763036242",
  location: "Batticaloa, Sri Lanka",
  professionalTitle: "Software Engineer | Backend Development | AI Integration",
  heroTitle: "Software Engineer | Backend Development | AI Integration",

  roles: [
    "Backend Software Engineer",
    "Full-Stack Developer",
    "Node.js Developer",
    "FastAPI Developer",
    "React.js Developer",
    "AI Integration Developer",
    "REST API Developer",
    "Laravel Developer",
    "CodeIgniter Developer",
    "PHP Developer"
  ],

  description:
    "My BSc (Hons) Industrial Information Technology studies at Uva Wellassa University, Sri Lanka, connect software engineering with applied research. Through two internships and personal projects, I've worked with React, Next.js, Node.js, Express, FastAPI, Laravel, PHP, PostgreSQL, MySQL, and MongoDB.",

  heroDescription:
    "I build backend services, REST APIs, and full-stack applications that connect people with the tools they need. My work combines database design, AI integration, and hands-on problem-solving across client projects and assistive technology research.",

  github: "https://github.com/Jeyapragash1",
  resume: `${process.env.PUBLIC_URL || '.'}/Kisho_Jeyapragash__CV.pdf`,
  linkedin: "https://www.linkedin.com/in/kisho-jeyapragash/",
  twitter: "https://x.com/JeyaPragash015",
  insta: "https://www.instagram.com/pragash_kv/profilecard/?igsh=M3Rwbzl6OWQ5OW8y",
  facebook: "https://www.facebook.com/k.jeyapragas"
};

export const skills = [
  {
    title: 'Backend Development',
    skills: [
      { name: 'Python', image: 'https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg' },
      { name: 'Node.js', image: 'https://nodejs.org/static/images/logo.svg' },
      { name: 'Express.js', image: 'https://upload.wikimedia.org/wikipedia/commons/6/64/Expressjs.png' },
      { name: 'FastAPI', image: 'https://fastapi.tiangolo.com/img/logo-margin/logo-teal.png' },
      { name: 'Laravel', image: 'https://upload.wikimedia.org/wikipedia/commons/9/9a/Laravel.svg' },
      { name: 'CodeIgniter', image: 'https://cdn.worldvectorlogo.com/logos/codeigniter.svg' },
      { name: 'PHP', image: 'https://www.php.net/images/logos/new-php-logo.svg' },
      { name: 'REST API Development', image: 'https://cdn-icons-png.flaticon.com/512/2165/2165004.png' },
      { name: 'JWT Authentication', image: 'https://jwt.io/img/pic_logo.svg' },
      { name: 'MVC Architecture', image: 'https://cdn-icons-png.flaticon.com/512/8759/8759045.png' },
      { name: 'Role-Based Access Control', image: 'https://cdn-icons-png.flaticon.com/512/3064/3064197.png' }
    ]
  },

  {
    title: 'Frontend Development',
    skills: [
      { name: 'React.js', image: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg' },
      { name: 'Next.js', image: 'https://upload.wikimedia.org/wikipedia/commons/8/8e/Nextjs-logo.svg' },
      { name: 'JavaScript', image: 'https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png' },
      { name: 'TypeScript', image: 'https://upload.wikimedia.org/wikipedia/commons/4/4c/Typescript_logo_2020.svg' },
      { name: 'HTML5', image: 'https://upload.wikimedia.org/wikipedia/commons/6/61/HTML5_logo_and_wordmark.svg' },
      { name: 'CSS3', image: 'https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg' },
      { name: 'Tailwind CSS', image: 'https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg' },
      { name: 'Bootstrap', image: 'https://upload.wikimedia.org/wikipedia/commons/b/b2/Bootstrap_logo.svg' }
    ]
  },

  {
    title: 'Databases',
    skills: [
      { name: 'MongoDB', image: 'https://webimages.mongodb.com/_com_assets/cms/mongodb-logo-rgb-j6w271g1xn.jpg' },
      { name: 'PostgreSQL', image: 'https://www.postgresql.org/media/img/about/press/elephant.png' },
      { name: 'MySQL', image: 'https://www.mysql.com/common/logos/logo-mysql-170x115.png' }
    ]
  },

  {
    title: 'AI and Automation',
    skills: [
      { name: 'OpenAI API', image: 'https://upload.wikimedia.org/wikipedia/commons/0/04/ChatGPT_logo.svg' },
      { name: 'Gemini API', image: 'https://upload.wikimedia.org/wikipedia/commons/8/8a/Google_Gemini_logo.svg' },
      { name: 'Hugging Face', image: 'https://huggingface.co/front/assets/huggingface_logo-noborder.svg' },
      { name: 'OpenCV', image: 'https://upload.wikimedia.org/wikipedia/commons/3/32/OpenCV_Logo_with_text_svg_version.svg' },
      { name: 'MediaPipe', image: 'https://cdn-icons-png.flaticon.com/512/2165/2165004.png' }
    ]
  },

  {
    title: 'DevOps and Development Tools',
    skills: [
      { name: 'Git', image: 'https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png' },
      { name: 'GitHub', image: 'https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png' },
      { name: 'Docker', image: 'https://www.docker.com/wp-content/uploads/2022/03/Moby-logo.png' },
      { name: 'Postman', image: 'https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg' },
      { name: 'VS Code', image: 'https://code.visualstudio.com/assets/images/code-stable.png' },
      { name: 'Render', image: 'https://render.com/favicon.ico' },
      { name: 'Vercel', image: 'https://assets.vercel.com/image/upload/v1662130559/front/assets/design/vercel-triangle-black.svg' }
    ]
  },

  {
    title: 'Software Engineering Practices',
    skills: [
      { name: 'Agile/Scrum', image: 'https://cdn-icons-png.flaticon.com/512/11456/11456856.png' },
      { name: 'REST API Design', image: 'https://cdn-icons-png.flaticon.com/512/2165/2165004.png' },
      { name: 'Database Design', image: 'https://cdn-icons-png.flaticon.com/512/4248/4248443.png' },
      { name: 'Responsive Web Development', image: 'https://cdn-icons-png.flaticon.com/512/545/545245.png' },
      { name: 'Clean Code', image: 'https://cdn-icons-png.flaticon.com/512/2721/2721297.png' }
    ]
  }
];

export const education = [
  {
    id: 0,
    img: "https://adaderanaenglish.s3.amazonaws.com/1656482205-Academic-activities-at-Uva-Wellassa-University-temporarily-halted-L.jpg",
    school: "Uva Wellassa University",
    date: "Expected Graduation 2026",
    grade: "Ongoing",
    desc: "My degree studies cover software development, databases, AI, and information systems. I applied those subjects in my completed eye-gaze communication research project.",
    degree: "BSc (Hons) Industrial Information Technology",
  },
  {
    id: 2,
    img: "https://adaderanaenglish.s3.amazonaws.com/1595500106-Medical-faculty-to-be-established-at-Moratuwa-University-L.jpg",
    school: "University of Moratuwa (Open Learning Platform)",
    date: "2022",
    grade: "Completed",
    desc: "I completed Python programming studies through the University of Moratuwa Open Learning Platform, strengthening my programming fundamentals and problem-solving skills.",
    degree: "Python Programming Course",
  },
  {
    id: 1,
    img: "https://esoft.lk/wp-content/uploads/2021/02/cropped-esoft-logo.png",
    school: "ESOFT Metro Campus",
    date: "2019",
    grade: "Completed",
    desc: "I completed a Diploma in Information Technology, building a foundation in programming, databases, and web development.",
    degree: "Diploma in Information Technology",
  }
];

export const experiences = [
  {
    id: 0,
    img: `${process.env.PUBLIC_URL || '.'}/images/jepsoft.png`,
    role: "Software Engineering Intern",
    company: "Jepsoft",
    date: "September 2025 – March 2026",
    desc: "I worked on client applications at Jepsoft, developing PHP, Laravel, and CodeIgniter backend features alongside React and Next.js interfaces. My work included REST APIs, database-driven workflows, responsive UI improvements, testing, and debugging across Premium Rent & Ride, EV Circle, YM Trading Japan, and Carbon Ceylon.",
    responsibilities: [
      "I developed backend features and REST APIs using PHP, Laravel, and CodeIgniter, including database-driven application workflows.",
      "I worked on React and Next.js interfaces, improving UI consistency, responsive layouts, and API integration.",
      "I tested application flows, debugged issues, and investigated performance problems.",
      "My project work included Premium Rent & Ride, EV Circle, YM Trading Japan, and Carbon Ceylon."
    ],
    skills: [
      "Laravel",
      "CodeIgniter",
      "React",
      "Next.js",
      "REST APIs",
      "PHP",
      "Production Fixes",
      "Performance Optimization"
    ],
  },
  {
    id: 1,
    img: `${process.env.PUBLIC_URL || '.'}/images/softwarepluse.jpeg`,
    role: "AI-Enabled Software Engineer Intern",
    company: "SoftwarePlus (Pvt) Ltd",
    date: "June 2025 – December 2025",
    desc: "I worked on government information and citizen-service applications at SoftwarePlus, including Smart Citizen LK. I developed FastAPI backend services and React/Next.js interfaces, worked with PostgreSQL and MongoDB, and contributed to OpenAI and Gemini integrations.",
    responsibilities: [
      "I developed backend APIs with FastAPI for government information and citizen-service workflows.",
      "I worked on React and Next.js features and connected frontend screens with backend services.",
      "I used PostgreSQL and MongoDB to support application data and database-driven workflows.",
      "I contributed to OpenAI and Gemini API integrations within full-stack applications."
    ],
    skills: [
      "Smart Citizen Platform",
      "FastAPI",
      "React",
      "Next.js",
      "MongoDB",
      "PostgreSQL",
      "OpenAI",
      "Gemini"
    ],
  }
];

export const research = [
  {
    id: 0,
    title: "Development of an Adaptive Eye-Gaze Communication and Control System for Locked-in Syndrome",
    focus: ["OpenCV", "MediaPipe", "Eye-Gaze Tracking", "Nine-Point Calibration", "Assistive Communication"],
    desc: "I completed my academic research by developing a webcam-based eye-gaze communication and control system. It brings together computer vision, adaptive calibration, and accessible interaction to help people communicate using eye movements.",
    problem: "Locked-in Syndrome can severely restrict speech and movement while a person remains aware of their surroundings. I focused on using eye movements as a way to communicate and interact with a computer through an everyday webcam.",
    solution: "I used OpenCV and MediaPipe for facial and iris landmark detection, eye selection and tracking, adaptive nine-point calibration, and low-light enhancement. Blink and dwell interactions support QuickTalk, an eye-controlled keyboard, and text-to-speech.",
    implementation: "I implemented patient registration and profiles, face-recognition login, QuickTalk communication, a virtual eye-controlled keyboard, text-to-speech, and emergency SOS workflows. Session logging supports research evaluation and review of how the interface is used.",
    methodology: "I evaluated the developed system with healthy volunteers and received positive feedback on their experience using the eye-gaze interface.",
    features: ["Webcam-based eye-gaze tracking with OpenCV and MediaPipe facial and iris landmarks", "Adaptive nine-point calibration, eye selection, and tracking", "Blink-based interaction and dwell-based selection", "Low-light image enhancement", "Patient registration, profile management, and face-recognition login", "QuickTalk, virtual eye-controlled keyboard, and text-to-speech", "Emergency SOS workflows", "Research evaluation and session logging"]
  }
];

// Add only confirmed credentials/achievements. Renderers omit missing URLs and values.
export const certifications = [];
export const achievements = [];

export const leadership = [
  {
    id: 0,
    role: "IEEE Webmaster",
    organization: "IEEE",
    desc: "As IEEE Webmaster, I worked on the chapter's web presence and supported technical coordination and digital communication."
  },
  {
    id: 1,
    role: "FOSS Technical Team Lead",
    organization: "FOSS Community",
    desc: "As FOSS Technical Team Lead, I coordinated technical collaboration and supported open-source activities within the university community."
  }
];

export const projects = [
  {
    title: "Weekly Report Generator",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1200&q=80",
    isFeatured: true,
    description: "Production-ready weekly reporting platform with team dashboard, report workflows, data modeling, and full-stack product architecture.",
    problem: "Teams need a structured way to create, review, and track weekly progress reports without scattered spreadsheets or manual follow-ups.",
    solution: "Built a full-stack reporting and dashboard system with typed frontend, backend APIs, PostgreSQL data modeling, and Prisma-powered persistence.",
    highlights: [
      "Team reporting dashboard and weekly report workflows",
      "PostgreSQL and Prisma data modeling",
      "Strong full-stack architecture with React, Node.js, and Express"
    ],
    technologies: ["TypeScript", "React", "Node.js", "Express", "PostgreSQL", "Prisma"],
    category: "Featured",
    githubLink: "https://github.com/jeyapragash1/weekly-report-generator",
    webAppLink: "",
  },
  {
    title: "AI AutoWorker",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=1200&q=80",
    isFeatured: true,
    description: "AI autonomous task assistant for reliable, observable automation with task execution, PostgreSQL persistence, and OpenAI integration.",
    problem: "Manual orchestration and monitoring of long-running automation tasks lacked visibility and resilience.",
    solution: "Built an AI-assisted task platform with modern full-stack architecture, persistent task state, and OpenAI-powered automation support.",
    highlights: [
      "AI autonomous task assistant architecture",
      "PostgreSQL-backed task persistence",
      "Modern TypeScript, Next.js, Node.js, and OpenAI stack"
    ],
    technologies: ["TypeScript", "Next.js", "Node.js", "PostgreSQL", "OpenAI"],
    category: "Featured",
    githubLink: "https://github.com/jeyapragash1/ai-autoworker",
    webAppLink: "",
  },
  {
    title: "EventFlow SaaS",
    image: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=1200&q=80",
    isFeatured: true,
    description: "Multi-tenant SaaS ERP concept for event businesses covering CRM, inventory, payments, workflows, and API-first service architecture.",
    problem: "Event businesses often manage CRM, inventory, payments, and workflows across disconnected tools.",
    solution: "Designed an API-first SaaS ERP structure for managing event operations through a scalable, business-focused platform model.",
    highlights: [
      "Multi-tenant SaaS ERP scope",
      "CRM, inventory, payments, and workflow modules",
      "Enterprise-oriented system design signal"
    ],
    technologies: ["API-first Architecture", "SaaS", "ERP", "Workflow Systems", "Database-backed Services"],
    category: "Featured",
    githubLink: "https://github.com/jeyapragash1/eventflow-saas",
    webAppLink: "",
  },
  {
    title: "EFCE Platform",
    image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1200&q=80",
    isFeatured: true,
    description: "Incident analytics platform with causal graph analysis, simulation, reporting, tests, and CI-focused engineering practices.",
    problem: "Incident and risk workflows need structured analytics to understand causes, simulate impact, and generate reports.",
    solution: "Built a Python-based analytics platform focused on incident analysis, causal graph modeling, simulation, and reporting workflows.",
    highlights: [
      "Incident analytics and risk-domain modeling",
      "Causal graph and simulation-oriented workflow",
      "Testing and CI mentioned in the repository summary"
    ],
    technologies: ["Python", "Analytics", "Testing", "CI", "Reporting"],
    category: "Featured",
    githubLink: "https://github.com/jeyapragash1/efce-platform",
    webAppLink: "",
  },
  {
    title: "Amazon Sales Analyze",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=80",
    isFeatured: true,
    description: "Enterprise-style e-commerce analytics narrative platform focused on Amazon sales analysis, insight generation, and data storytelling.",
    problem: "Raw sales datasets are difficult to understand without clear analysis flows, visual interpretation, and business storytelling.",
    solution: "Created a Python analytics project that turns e-commerce sales data into structured analysis and narrative insight.",
    highlights: [
      "Python-based e-commerce analytics",
      "Sales insight and data storytelling focus",
      "Business-oriented analytics presentation"
    ],
    technologies: ["Python", "Data Analytics", "Sales Analysis", "Reporting"],
    category: "Featured",
    githubLink: "https://github.com/jeyapragash1/Amazon_sales_analyze",
    webAppLink: "",
  },
  {
    title: "Smart Citizen Platform",
    image: "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1f?auto=format&fit=crop&w=1200&q=80",
    isFeatured: true,
    description: "Smart-city citizen services platform with TypeScript frontend and Python backend companion for service workflows and citizen-facing operations.",
    problem: "Citizen services need clearer digital access, better workflow organization, and separate frontend/backend responsibilities.",
    solution: "Built a Smart Citizen frontend and backend companion to support smart-city service interactions and administrative workflows.",
    highlights: [
      "TypeScript smart-city citizen services frontend",
      "Python backend companion project",
      "Service workflow and civic platform focus"
    ],
    technologies: ["TypeScript", "Python", "Frontend", "Backend", "Citizen Services"],
    category: "Featured",
    githubLink: "https://github.com/jeyapragash1/Smart-Citizen",
    webAppLink: "",
  },
  {
    title: "Low-Code Workflow Automation Platform",
    image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1200&q=80",
    isFeatured: true,
    description: "Visual workflow automation platform with node-based workflow creation and execution-engine thinking.",
    problem: "Non-technical users could not safely build and operate automated workflows without engineering support.",
    solution: "Built a visual low-code workflow platform for designing and running automated workflow processes.",
    highlights: [
      "Visual workflow automation",
      "Execution-engine architecture",
      "Applied workflow/product thinking"
    ],
    technologies: ["JavaScript", "Workflow Automation", "Visual Builder", "Execution Engine"],
    category: "Featured",
    githubLink: "https://github.com/jeyapragash1/low-code-workflow-platform",
    webAppLink: "",
  },
  {
    title: "TDC Matchmaker Dashboard",
    image: "https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=1200&q=80",
    isFeatured: false,
    description: "Dashboard-style TypeScript application focused on matchmaker workflows and operational decision support.",
    problem: "Dashboard workflows need structured data views and clear operational interaction patterns.",
    solution: "Built a TypeScript dashboard-style application for matchmaker-focused workflow management.",
    highlights: [
      "TypeScript dashboard application",
      "Operational workflow focus",
      "Modern frontend/dashboard project signal"
    ],
    technologies: ["TypeScript", "Dashboard", "Frontend"],
    category: "Dashboard",
    githubLink: "https://github.com/jeyapragash1/tdc-matchmaker-dashboard",
    webAppLink: "",
  },
  {
    title: "GlobalTNA Service Request Board",
    image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?auto=format&fit=crop&w=1200&q=80",
    isFeatured: false,
    description: "Service request board and task workflow application for managing operational requests.",
    problem: "Service teams need a clear board for tracking incoming requests and task progress.",
    solution: "Created a JavaScript service request board focused on workflow visibility and task handling.",
    highlights: [
      "Service request workflow board",
      "Task tracking focus",
      "Applied operations dashboard project"
    ],
    technologies: ["JavaScript", "Service Requests", "Workflow Board"],
    category: "Dashboard",
    githubLink: "https://github.com/jeyapragash1/globaltna-service-request-board",
    webAppLink: "",
  },
  {
    title: "Hiring Full-Stack Todo",
    image: "https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?auto=format&fit=crop&w=1200&q=80",
    isFeatured: false,
    description: "Full-stack CRUD and REST API application built with React, Node.js, Express, and MongoDB.",
    problem: "Hiring exercises often need clean CRUD flows, API structure, and frontend/backend integration.",
    solution: "Built a full-stack todo application demonstrating REST APIs, MongoDB persistence, and React UI integration.",
    highlights: [
      "Full-stack CRUD implementation",
      "React frontend with Node.js and Express backend",
      "MongoDB-backed REST API workflow"
    ],
    technologies: ["React", "Node.js", "Express", "MongoDB", "REST APIs"],
    category: "Full Stack",
    githubLink: "https://github.com/jeyapragash1/hiring-fullstack-todo",
    webAppLink: "",
  },
  {
    title: "Deep Space Snap",
    image: "https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?auto=format&fit=crop&w=1200&q=80",
    isFeatured: false,
    description: "JavaScript astronomy image and data web application.",
    problem: "Astronomy image/data experiences need a focused interface for exploration and presentation.",
    solution: "Built a JavaScript-based astronomy web application focused on image and data interaction.",
    highlights: [
      "Astronomy image/data web app",
      "JavaScript project implementation",
      "Domain-focused visual application"
    ],
    technologies: ["JavaScript", "Web App", "Astronomy Data"],
    category: "Web App",
    githubLink: "https://github.com/jeyapragash1/Deep_spaceSnap",
    webAppLink: "",
  },
  {
    title: "Smart Management System",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=80",
    isFeatured: false,
    description: "JavaScript management system application for practical administrative workflows.",
    problem: "Management workflows need organized interfaces for handling records and operational tasks.",
    solution: "Created a JavaScript management system app focused on practical CRUD and workflow organization.",
    highlights: [
      "Management system project",
      "JavaScript application stack",
      "Administrative workflow focus"
    ],
    technologies: ["JavaScript", "Management System", "Web App"],
    category: "Web App",
    githubLink: "https://github.com/jeyapragash1/Smart-Management-System",
    webAppLink: "",
  },
  {
    title: "EventLanka",
    image: "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=1200&q=80",
    isFeatured: false,
    description: "PHP and MySQL event booking and admin system for event services, booking workflows, and management operations.",
    problem: "Event organizers lacked a centralized system for bookings, services, and admin workflows.",
    solution: "Implemented a PHP and MySQL event platform with booking and administration flows.",
    highlights: [
      "Event booking/admin platform",
      "PHP and MySQL practical system",
      "Service and booking workflow management"
    ],
    technologies: ["PHP", "MySQL", "JavaScript"],
    category: "Full Stack",
    githubLink: "https://github.com/Jeyapragash1/Event-Lanka",
    webAppLink: "https://youtu.be/7N1IkrZwQLo?si=9jMaVOHT_e0x_idU",
  },
  {
    title: "Home Security System",
    image: "https://images.unsplash.com/photo-1558002038-1055907df827?auto=format&fit=crop&w=1200&q=80",
    isFeatured: false,
    description: "Visitor and security management system built with PHP, MySQL, and JavaScript.",
    problem: "Homes and small businesses need a lightweight way to manage visitor/security records.",
    solution: "Built a practical visitor/security management system with PHP, MySQL, and JavaScript workflows.",
    highlights: [
      "Visitor/security management",
      "PHP and MySQL practical CRUD system",
      "JavaScript-enhanced web interface"
    ],
    technologies: ["PHP", "MySQL", "JavaScript"],
    category: "System App",
    githubLink: "https://github.com/Jeyapragash1/Home-Security-system",
    webAppLink: "https://youtu.be/aIiUH5EBx9I?si=cuYIBpGQE8pQrVXe",
  },
  {
    title: "IAS Blog Backend",
    image: "https://images.unsplash.com/photo-1499750310107-5fef28a66643?auto=format&fit=crop&w=1200&q=80",
    isFeatured: false,
    description: "Python backend for an IAS chapter blog project.",
    problem: "Chapter websites need backend support for blog/content workflows.",
    solution: "Created a Python backend project for IAS chapter blog management.",
    highlights: [
      "Python backend project",
      "Blog/content workflow focus",
      "Chapter-oriented backend system"
    ],
    technologies: ["Python", "Backend", "Blog API"],
    category: "Backend",
    githubLink: "https://github.com/jeyapragash1/backen_ias_blog",
    webAppLink: "",
  },
  {
    title: "IEEE IAS Chapter",
    image: "https://images.unsplash.com/photo-1515187029135-18ee286d815b?auto=format&fit=crop&w=1200&q=80",
    isFeatured: false,
    description: "JavaScript chapter website/project for IEEE IAS activities and content presentation.",
    problem: "Student chapter activities need an organized web presence for events, information, and content.",
    solution: "Built a JavaScript-based chapter website/project for IEEE IAS presentation and activity support.",
    highlights: [
      "IEEE IAS chapter web project",
      "JavaScript frontend implementation",
      "Community/chapter presentation focus"
    ],
    technologies: ["JavaScript", "Website", "Frontend"],
    category: "Web App",
    githubLink: "https://github.com/jeyapragash1/IEEE-IAS-Chapter",
    webAppLink: "",
  },
  {
    title: "Hospital Appointment System",
    image: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=1200&q=80",
    isFeatured: false,
    description: "Java and MySQL appointment system for hospital booking and management workflows.",
    problem: "Hospitals need structured appointment booking and management workflows.",
    solution: "Built a Java and MySQL hospital appointment system for scheduling and administration.",
    highlights: [
      "Hospital appointment workflows",
      "Java and MySQL implementation",
      "Academic/practical backend system"
    ],
    technologies: ["Java", "MySQL"],
    category: "Archive",
    githubLink: "https://github.com/Jeyapragash1/Hospital-Appointment-system",
    webAppLink: "https://youtu.be/6oz336altVU?si=xYEnCKhgfNUXJ_zo",
  },
  {
    title: "Enhanced Hospital System",
    image: "https://images.unsplash.com/photo-1538108149393-fbbd81895907?auto=format&fit=crop&w=1200&q=80",
    isFeatured: false,
    description: "Second Java and MySQL hospital appointment system iteration with improved workflow handling.",
    problem: "The original appointment workflow needed iteration and better management structure.",
    solution: "Created a second hospital appointment system variant to improve structure and workflow handling.",
    highlights: [
      "Hospital system iteration",
      "Java and MySQL stack",
      "Improved appointment workflow handling"
    ],
    technologies: ["Java", "MySQL"],
    category: "Archive",
    githubLink: "https://github.com/Jeyapragash1/Hospital-appointment-system2",
    webAppLink: "",
  },
  {
    title: "Voting System Using JSP",
    image: "https://images.unsplash.com/photo-1540910419892-4a36d2c3266c?auto=format&fit=crop&w=1200&q=80",
    isFeatured: false,
    description: "Java/JSP voting system focused on web-based election workflows.",
    problem: "Voting workflows need registration, authentication, vote casting, and result handling.",
    solution: "Built a Java/JSP voting system demonstrating web-based voting and administrative flows.",
    highlights: [
      "Java/JSP voting workflow",
      "Election-style academic system",
      "Web-based voting project"
    ],
    technologies: ["Java", "JSP"],
    category: "Archive",
    githubLink: "https://github.com/jeyapragash1/Voting-system-using-JSp",
    webAppLink: "",
  },
  {
    title: "Sri Lankan Job Portal",
    image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1200&q=80",
    isFeatured: false,
    description: "Java job portal project for job listings, applicant workflows, and employer-style interactions.",
    problem: "Job seekers and employers need a structured portal for listings and application workflows.",
    solution: "Built a Java-based job portal focused on practical employment platform features.",
    highlights: [
      "Java job portal project",
      "Job listing and application workflow",
      "Academic/enterprise-style system"
    ],
    technologies: ["Java"],
    category: "Archive",
    githubLink: "https://github.com/Jeyapragash1/Srilankan-job-portal",
    webAppLink: "",
  },
  {
    title: "On-Vote",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&w=1200&q=80",
    isFeatured: false,
    description: "Java voting-related application focused on voting workflow and result handling.",
    problem: "Voting processes need structured voter interaction and result management.",
    solution: "Created a Java voting-related application for academic election workflow practice.",
    highlights: [
      "Java voting-related app",
      "Election workflow practice",
      "Academic desktop/system project"
    ],
    technologies: ["Java"],
    category: "Archive",
    githubLink: "https://github.com/Jeyapragash1/On-Vote.git",
    webAppLink: "",
  }
];
